<template>
  <div class="login">
    <div class="right-box">
      <div class="login-box">
        <div class="title">欢迎登录</div>
        <el-form :model="form" ref="form" :rules="rules">
          <el-form-item prop="userName">
            <span class="prefix el-icon-p1"></span>
            <el-input v-model="form.userName" placeholder="请输入证件号码" clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <span class="prefix el-icon-p2"></span>
            <el-input v-model="form.password" placeholder="请输入手机号" type="password" clearable>
            </el-input>
          </el-form-item>
          <!-- <el-form-item prop="captcha">
            <span class="prefix el-icon-p3"></span>
            <el-input v-model="form.captcha"
                      placeholder="请输入验证码"
                      type="text"
                      @keyup.enter.native="login">
            </el-input>
            <div class="img-box">
              <img :src="imgurl"
                   @click="changeImg"
                   style="width: 100%; height: 100%" />
            </div>
          </el-form-item> -->
        </el-form>
        <el-button type="primary" class="login-btn" @click="login" v-preventReClick>登 录</el-button>
        <div class="remind-box ">
          <h3> <label>温馨提示：</label> </h3>
          <div>建议使用浏览器：<i class="google icon"></i>谷歌浏览器<i class="ie icon"></i>360安全浏览器</div>
          <div class="item">360安全浏览器请使用极速模式<span class="btn">( 如何使用? )<span class="img"><img
                  src="../assets/image/360.png" /></span></span></div>
        </div>
        <div class="bottom">
          技术支持: 杭州毕为科技有限公司
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      form: {
        password: "",
        userName: ""
      },
      // imgurl: "", // 验证码图片
      rules: {
        userName: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        // captcha: [
        //   {
        //     required: true,
        //     message: "请输入验证码",
        //     trigger: "blur",
        //   },
        // ],
      },
    };
  },
  methods: {
    changeImg() {
      // this.$http({
      //   url: '/login/captcha.jpg',
      //   method: 'get',   // get请求，post改为post
      //   responseType: 'blob', // 二进制类型的对象
      // }).then((res) => {
      //   console.log(res);
      //   let blob = new Blob([res.data], { type: 'image/jpeg' });   // 返回的文件流数据
      //   console.log(blob);
      //   let url = window.URL.createObjectURL(blob);  // 将他转化为路径
      //   console.log(url);
      //   this.imgurl = url  // 将转换出来的路径赋值给变量，其实和上一步结合就可以
      // }).catch(err => {
      //   console.error(err);
      // })
      // this.$http
      //   .get(`/login/captcha.jpg`, {
      //     responseType: "arraybuffer",
      //   })
      //   .then((response) => {
      //     return (
      //       "data:image/png;base64," +
      //       btoa(
      //         new Uint8Array(response.data).reduce(
      //           (data, byte) =>
      //             data + String.fromCharCode(byte),
      //           ""
      //         )
      //       )
      //     );
      //   })
      //   .then((res) => {
      //     this.imgurl = res;
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    login() {
      this.$http.post(`/login/user`, this.form).then((res) => {
        console.log(777,res);
        if (res.data.code == 1000) {
          this.$message.success(`登录成功`);
          
          this.$store.commit('updateUserData', res.data.data)
          this.$router.replace("/");
        }
      })
        .catch(error => {
          this.changeImg();
        })
    },
  },
  created() {
    // this.changeImg();
  },
};
</script>
<style lang="scss" scoped>
.login {
  position: relative;
  width: 100%;
  height: 100%;
  font-size: 16px;
  background: url("../assets/image/bg.jpg") no-repeat;
  background-size: cover;

  .right-box {
    width: 500px;
    margin-left: calc(100% - 650px);
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;

    .title {
      text-align: center;
      font-size: 28px;
      font-weight: 500;
      color: #fff;
      margin-bottom: 20px;
    }

    .login-box {
      width: 85%;
      padding: 20px 20px;
      background-color: rgba($color: #fff, $alpha: 0.4);
      border-radius: 20px;

      .bottom {
        width: 100%;
        font-size: 13px;
        text-align: center;
        color: #fff;
        bottom: 20px;
      }
    }

    .el-form-item {
      background-color: #f4faff;
      // background-color: ;
      border-radius: 8px;

      /deep/ .el-form-item__content {
        display: flex;
        align-items: center;
        line-height: 50px;
        background: #fff;
        border-radius: 5px;
      }
    }

    .el-input {
      font-size: 18px;

      /deep/ .el-input__inner {
        border: 0 !important;
        background-color: transparent !important;
      }
    }

    .prefix {
      width: 30px;
      height: 30px;
      margin-left: 15px;
      flex-shrink: 0;
    }

    // 自定义icon
    .el-icon-p1 {
      background: url("../assets/image/p_1.png") no-repeat center;
      /*使用自己的图片来替换*/
      background-size: contain;
    }

    .el-icon-p1:before {
      content: "add";
      /*before属性中的content文本是用来占位的,必须有*/
      font-size: 40px;
      /*可以设置字体大小来确定图标大小*/
      visibility: hidden;
      /*使用visibility: hidden;来隐藏文字*/
    }

    .el-icon-p2 {
      background: url("../assets/image/p_2.png") no-repeat center;
      /*使用自己的图片来替换*/
      background-size: contain;
    }

    .el-icon-p2:before {
      content: "add";
      /*before属性中的content文本是用来占位的,必须有*/
      font-size: 40px;
      /*可以设置字体大小来确定图标大小*/
      visibility: hidden;
      /*使用visibility: hidden;来隐藏文字*/
    }

    .el-icon-p3 {
      background: url("../assets/image/p_3.png") no-repeat center;
      /*使用自己的图片来替换*/
      background-size: contain;
    }

    .el-icon-p3:before {
      content: "add";
      /*before属性中的content文本是用来占位的,必须有*/
      font-size: 40px;
      /*可以设置字体大小来确定图标大小*/
      visibility: hidden;
      /*使用visibility: hidden;来隐藏文字*/
    }

    .img-box {
      width: 140px;
      height: 50px;
      flex-shrink: 0;
    }

    .login-btn {
      width: 100%;
      height: 50px;
      font-size: 20px;
    }
  }
}

.remind-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  // color: $;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
  box-sizing: border-box;
  padding: 20px 0;
  color: #fff;

  h3 {
    font-weight: normal;
    font-size: 14px;
  }

  label {
    font-weight: bold;
  }

  div {
    display: flex;
    width: 100%;
    text-indent: 1em;
    align-items: center;

    .btn {
      //   position: relative;
      // color: $;
      text-decoration: underline;
      cursor: pointer;
    }

    .btn:hover .img {
      display: block;
    }

    .img {
      display: none;
      position: absolute;
      right: 30vw;
      top: 40vh;
      width: 600px;
      height: auto;
      z-index: 9999;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-repeat: no-repeat;
    vertical-align: middle;
    background-size: 16px 16px;
  }

  .google {
    background-image: url("../assets/image/geogle.svg");
  }

  .ie {
    background-image: url("../assets/image/ie.svg");
  }
}
</style>